import loadable from '@loadable/component';

// 懒加载组件
const SupplierInvoiceManagement = loadable(() => import('./invoiceManagement/SupplierInvoiceManagement'));
const InvoiceManagement = loadable(() => import('./invoiceManagement/InvoiceManagement'));
export const subRoutes = [
  { // 【明光】供应商：供应商发票管理
    path: '/SupplierInvoiceManagement',
    component: SupplierInvoiceManagement
  },
  { // 【明光】供应商：供应商发票管理明细
    path: '/InvoiceManagement',
    component: InvoiceManagement
  }

];
